<template>
	<div class="page-order page-content" v-loading="body_loading">
		<div class="main-body">
			<el-row class="hd">
				<el-col :span="24">
					<h3 style="float: none;">已完成列表</h3>
					<div class="flex-block breadcrumb-box">
						<div class="position-text">位置：</div>
						<el-breadcrumb separator-class="el-icon-arrow-right">
							<el-breadcrumb-item>订单管理</el-breadcrumb-item>
							<el-breadcrumb-item>已完成列表</el-breadcrumb-item>
						</el-breadcrumb>
					</div>
				</el-col>
			</el-row>
			<div class="bd">
				<div class="search-block content-body">
					<el-form :inline="true" ref="formSearch" :model="form_search" class="demo-form-inline"
						@submit.native.prevent>
						<el-form-item prop="order_number" label="订单编号：" style="margin-bottom: 0;">
							<el-input v-model="form_search.order_number" size="small" placeholder="请输入订单号" clearable>
							</el-input>
						</el-form-item>
						<el-form-item prop="user_number" label="用户编号：" style="margin-bottom: 0;">
							<el-input v-model="form_search.user_number" size="small" placeholder="请输入用户编号" clearable>
							</el-input>
						</el-form-item>
		<!-- 				<el-form-item prop="card_number" label="实体卡号：" style="margin-bottom: 0;">
							<el-input v-model="form_search.card_number" size="small" placeholder="请输入实体卡号" clearable>
							</el-input>
						</el-form-item> -->
<!-- 						<el-form-item prop="desk_number" label="下单店铺：">
							<el-select size="small" v-model="form_search.desk_number" placeholder="请选择"
								style="width:100%;">
								<el-option v-for="item in init_data.desk_list" :key="item.number" :label="item.name"
									:value="item.number">
								</el-option>
							</el-select>
						</el-form-item> -->
						<!--        <el-form-item prop="order_mode" label="下单类型：">
                            <el-select size="small" v-model="form_search.order_mode" placeholder="请选择" style="width:100%;">
                                <el-option
                                        v-for="item in init_data.order_mode_list"
                                        :key="item.id"
                                        :label="item.name"
                                        :value="item.id">
                                </el-option>
                            </el-select>
                        </el-form-item> -->
						<el-form-item prop="status" label="状态：">
							<el-select size="small" v-model="form_search.status" placeholder="请选择" style="width:100%;">
								<el-option v-for="item in init_data.status_list" :key="item.id" :label="item.name"
									:value="item.id">
								</el-option>
							</el-select>
						</el-form-item>
						<el-form-item label="预定时间：">
							<el-date-picker size="small" clearable v-model="create_range" type="daterange"
								range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期"
								value-format="yyyy-MM-dd">
							</el-date-picker>
						</el-form-item>
						<el-form-item style="margin-bottom: 0;">
							<el-button type="primary" class="search-btn" size="medium" @click='searchList()'>查询
							</el-button>
						</el-form-item>
					</el-form>
				</div>
				<div class="table-block content-body">
					<div ref="contentBody">
						<el-table ref="multipleTable" :data="table_data.list" v-loading="table_data.loading"
							tooltip-effect="dark" style="width: 100%;text-align: center;">
							<el-table-column prop="order_number" align="center" label="订单编号" min-width="180">
								<template slot-scope="scope">
									<my-textEllipsis v-if="is_refresh" :content="scope.row.order_number">
									</my-textEllipsis>
								</template>
							</el-table-column>
	
							<el-table-column prop="desk_name" align="center" label="下单店铺名称" min-width="160">
								<template slot-scope="scope">
									<my-textEllipsis v-if="is_refresh" :content="scope.row.desk_name"></my-textEllipsis>
								</template>
							</el-table-column>
							<el-table-column prop="user_number" align="center" label="用户编号" min-width="180">
							</el-table-column>
							<!-- <el-table-column prop="card_number" align="center" label="实体卡号" min-width="230">
								<template slot-scope="scope">
									<my-textEllipsis v-if="is_refresh"
										:content="scope.row.card_number + '(' + scope.row.user_type_name + ')'">
									</my-textEllipsis>
								</template>
							</el-table-column> -->
							<el-table-column prop="sale_total_amount" align="center" label="订单总价" min-width="80">
							</el-table-column>
							<el-table-column prop="product_count" align="center" label="产品数量" min-width="80">
							</el-table-column>
							<el-table-column prop="discount_total_amount" align="center" label="优惠金额" min-width="100">
							</el-table-column>
							<el-table-column prop="paid_amount" align="center" label="订单实付" min-width="80">
								<template slot-scope="scope">
									<span class="c-red">{{scope.row.paid_amount}}</span>
								</template>
							</el-table-column>
							<el-table-column prop="refund_amount" align="center" label="退款金额" min-width="80">
								<template slot-scope="scope">
									<span class="c-red">{{scope.row.refund_amount}}</span>
								</template>
							</el-table-column>
							<el-table-column prop="remark" align="center" label="用户备注" min-width="200">
								<template slot-scope="scope">
									<my-textEllipsis v-if="is_refresh" :content="scope.row.remark"></my-textEllipsis>
								</template>
							</el-table-column>
							<el-table-column prop="appointment_time" align="center" label="预定时间" min-width="140">
								<template slot-scope="scope">
									<span>{{scope.row.appointment_time}} 预定</span>
								</template>
							</el-table-column>
							<el-table-column prop="c_time" sortable="custom" align="center" label="创建时间"
								min-width="160">
							</el-table-column>
							<el-table-column prop="pay_time" sortable="custom" align="center" label="支付时间"
								min-width="160">
							</el-table-column>
							<el-table-column prop="refund_date" sortable="custom" align="center" label="退款时间"
								min-width="160">
							</el-table-column>
							<el-table-column prop="cancel_time" sortable="custom" align="center" label="取消时间"
								min-width="160">
							</el-table-column>
							<!-- 						<el-table-column prop="mode_name" align="center" label="下单类型" min-width="120">
								<template slot-scope="scope">
									<span :class="'tag-span tag-'+scope.row.order_mode">{{scope.row.mode_name}}</span>
								</template>
							</el-table-column> -->
							<el-table-column prop="status_name" align="center" label="状态" min-width="80" fixed="right">
								<template slot-scope="scope">
									<span :class="'status-'+scope.row.status">{{scope.row.status_name}}</span>
								</template>
							</el-table-column>
							<el-table-column prop="refund_status_name" align="center" label="退款状态" min-width="80" fixed="right">
								<template slot-scope="scope">
									<span :class="'status-'+scope.row.refund_status">{{scope.row.refund_status_name}}</span>
								</template>
							</el-table-column>
							<el-table-column prop="operating" align="left" label="操作" min-width="200" fixed="right">
								<template slot-scope="scope">
									<el-button class="option-btn btn-bd-m" type="primary" size="mini" @click="goodsDetail(scope.row)">产品详情</el-button>
									<!-- <el-button class="option-btn btn-bd-g" type="primary" size="mini" @click="$util.goTo('/order/userorder',{query:{order_number:scope.row.order_number,status:scope.row.status,type:2}})">点单详情</el-button> -->
									<el-button v-if="scope.row.status!=10" class="option-btn btn-bd-rm" type="primary" size="mini" @click="cancelOrder(scope.row.order_number,scope.row.desk_name,scope.row.appointment_time)">取消订单</el-button>
									<!-- <el-button v-if="scope.row.order_mode==1" class="option-btn btn-bd-s" type="primary" size="mini" @click="printAll(scope.row.order_number)">打印总单</el-button> -->
									<!-- <el-button v-else-if="scope.row.order_mode==2" class="option-btn btn-bd-o" type="primary" size="mini" @click="printAll(scope.row.order_number)">打印总单</el-button> -->
									<!-- <el-button class="option-btn btn-bd-r" type="primary" size="mini" @click="printSort(scope.row.order_number)">打印分拣单</el-button> -->
									<!-- <el-button v-if="scope.row.order_mode==1" class="option-btn btn-bd-p" type="primary" size="mini" @click="printFinance(scope.row.order_number)">财务打单</el-button> -->
									<!-- <el-button v-else-if="scope.row.order_mode==2" class="option-btn btn-bd-p" type="primary" size="mini" @click="printFinancePerson(scope.row.order_number)">财务打单</el-button> -->
								</template>
							</el-table-column>
						</el-table>
					</div>
					<el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
						:current-page="table_data.page_info.page" :page-sizes="[10,30, 50,80,100]"
						:page-size="table_data.page_info.pageSize" layout="total, sizes, prev, pager, next"
						:total="table_data.page_info.total">
					</el-pagination>
				</div>
				<el-dialog class="dialog-export activity-dialog" :title="dlg_goods.title"
					:visible.sync="dlg_goods.visible" width="800px" :close-on-click-modal="false">
					<el-row>
						<el-table ref="multipleTable" :data="dlg_goods.table_data.list"
							v-loading="dlg_goods.table_data.loading" max-height="600px" tooltip-effect="dark"
							style="width: 100%;text-align: center;">
							<el-table-column prop="product_name" align="center" label="产品名称" min-width="180">
								<template slot-scope="scope">
									<my-textEllipsis v-if="is_refresh" :content="scope.row.product_name">
									</my-textEllipsis>
								</template>
							</el-table-column>
							<el-table-column prop="product_intro" align="center" label="产品简介" min-width="200">
								<template slot-scope="scope">
									<my-textEllipsis v-if="is_refresh" :content="scope.row.product_intro">
									</my-textEllipsis>
								</template>
							</el-table-column>
							<el-table-column prop="product_count" align="center" label="产品数量" min-width="120">
								<template slot-scope="scope">
									<span>{{scope.row.product_count}}{{scope.row.product_unit}}</span>
								</template>
							</el-table-column>
							<el-table-column prop="sale_total_amount" align="center" label="实付金额" min-width="120">
							</el-table-column>
							<!-- <el-table-column prop="discount_total_amount" align="center" label="立减金额" min-width="120">
	        <template slot-scope="scope">
	            <span class="c-red">{{scope.row.discount_total_amount}}</span>
	        </template>
	    </el-table-column>-->
							<el-table-column prop="image_url" align="center" label="产品图片" min-width="80">
								<template slot-scope="scope">
									<img class="cursor" :src="baseUrl + scope.row.product_image_url_s" height="23"
										@click="dlg_preview.img_url = baseUrl + scope.row.product_image_url;dlg_preview.visible = true;"
										title="点击查看" />
								</template>
							</el-table-column>
						</el-table>
					</el-row>

					<el-row style="text-align: center;padding: 25px;">收货信息：{{dlg_goods.consignee_addr}}
						{{dlg_goods.consignee}} {{dlg_goods.consignee_phone}}</el-row>
				</el-dialog>
				<el-dialog class="dialog-export cancel-dialog" :title="dlg_cancel.title"
					:visible.sync="dlg_cancel.visible" width="534px" @closed="closeCancel"
					:close-on-click-modal="false">
					<el-form ref="formCancel" :model="dlg_cancel.form" label-width="110px" :rules="dlg_cancel.rules"
						@submit.native.prevent>
						<el-form-item prop="description" label="取消原因：">
							<el-input v-model="dlg_cancel.form.cancel_remark" type="textarea" :rows="3" size="small"
								placeholder="请输入取消原因"></el-input>
						</el-form-item>
					</el-form>
					<span slot="footer" class="dialog-footer">
						<el-button @click="dlg_cancel.visible = false">关 闭</el-button>
						<el-button type="primary" @click="submitCancel()" :loading="dlg_cancel.btn_loading">确认取消
						</el-button>
					</span>
				</el-dialog>

				<el-dialog :visible.sync="dlg_preview.visible" class="dialog-no-title text-center" width="420px">
					<img width="100%" :src="dlg_preview.img_url" style="max-width:100%;">
				</el-dialog>
			</div>
		</div>
	</div>
</template>
<script>
	export default {
		name: 'usercenter',
		data() {
			return {
				clientHeight: '',
				baseUrl: this.$client.IMG_URL,
				body_loading: false,
				is_refresh: true,
				create_range: '',
				form_search: {
					order_number: this.$route.query.order_number == undefined? '' : this.$route.query.order_number,
					user_number: '',
					card_number: '',
					desk_number: "",
					order_mode: -1,
					status: -1,
					start_appointment_date: '',
					end_appointment_date: ''
				},
				init_data: {
					desk_list: [],
					order_mode_list: [],
					status_list: []
				},
				table_data: {
					loading: false,
					list: [],
					page_info: {
						page: 1,
						pageSize: 10,
						total: 130
					}
				},
				dlg_goods: {
					title: '',
					visible: false,
					consignee: '',
					consignee_addr: '',
					consignee_phone: '',
					table_data: {
						loading: false,
						list: []
					}
				},
				dlg_cancel: {
					title: '取消订单',
					visible: false,
					form: {
						order_number: '',
						cancel_remark: ''
					}
				},
				dlg_preview: {
					visible: false,
					img_url: ''
				}
			}
		},
		created() {
			document.title = '已完成列表';
			this.getList();
		},
		methods: {
			searchList() {
				var _this = this;
				_this.table_data.page_info.page = 1;
				_this.getList();
			},
			getList() {
				var _this = this;
				var params = _this.form_search;
				params.p = _this.table_data.page_info.page;
				params.pageSize = _this.table_data.page_info.pageSize;
				_this.table_data.loading = true;
				var desk_list = [{
					number: '',
					name: '全部'
				}];
				var status_list = [{
					id: -1,
					name: '全部'
				}];
				this.$client.get('/adminapi/order/joinorderlist', params, function(res, message) {
					_this.table_data.list = res.list;
					_this.table_data.page_info = res.pager;
					_this.init_data.desk_list = desk_list.concat(res.desk_list);
					_this.init_data.status_list = status_list.concat(res.status_name_list);
					_this.init_data.order_mode_list = status_list.concat(res.order_mode_list);
					_this.table_data.loading = false;
				}, function(res) {
					_this.table_data.loading = false;
				});
			},
			handleSizeChange(val) {
				//console.log(`每页 ${val} 条`);
				this.table_data.page_info.pageSize = val;
				this.getList();
			},
			handleCurrentChange(val) {
				//console.log(`当前页: ${val}`);
				this.table_data.page_info.page = val;
				this.getList();
			},
			goodsDetail(data) {
                this.dlg_goods.visible = true;
				this.dlg_goods.table_data.list = data.items;
                this.dlg_goods.consignee = data.consignee;
				this.dlg_goods.consignee_addr = data.consignee_addr;
				this.dlg_goods.consignee_phone = data.consignee_phone;
			},
			// printAll(order_number) {
			// 	var _this = this;
			// 	var params = {
			// 		order_number: order_number
			// 	};
			// 	this.$client.post('/adminapi/order/printkitchenorder', params, function(res, message) {
			// 		_this.$message(message);
			// 	}, function(res) {

			// 	});
			// },
			// printSort(order_number) {
			// 	var _this = this;
			// 	var params = {
			// 		order_number: order_number
			// 	};
			// 	this.$client.post('/adminapi/order/printpackageorder', params, function(res, message) {
			// 		_this.$message(message);
			// 	}, function(res) {

			// 	});
			// },
			// printFinance(order_number) {
			// 	var _this = this;
			// 	var params = {
			// 		order_number: order_number
			// 	};
			// 	this.$client.post('/adminapi/order/printfinanceorder', params, function(res, message) {
			// 		_this.$message(message);
			// 	}, function(res) {

			// 	});
			// },
			// printFinancePerson(order_number) {
			// 	var _this = this;
			// 	var params = {
			// 		order_number: order_number
			// 	};
			// 	this.$client.post('/adminapi/order/printfinanceorder2', params, function(res, message) {
			// 		_this.$message(message);
			// 	}, function(res) {

			// 	});
			// },
			cancelOrder(order_number, desk_name, appointment_time) {
				this.dlg_cancel.visible = true;
				this.dlg_cancel.title = '取消-' + desk_name + '-' + appointment_time + ' 预定订单';
				this.dlg_cancel.form.order_number = order_number;
			},
			submitCancel() {
				var _this = this;
				this.$client.post('/adminapi/order/cancelorder', this.dlg_cancel.form, function(res, message) {
					_this.$message(message);
					_this.dlg_cancel.visible = false;
					_this.getList();
				}, function(res) {

				});
			},
			closeCancel() {
				this.dlg_cancel.form.order_number = '';
				this.dlg_cancel.form.cancel_remark = '';
			},
			changeFixed(clientHeight) {
				this.$refs.contentBody.style.minHeight = (clientHeight - 394) + 'px';
			}
		},
		mounted() {
			// 获取浏览器可视区域高度
			this.clientHeight = `${document.documentElement.clientHeight}` //document.body.clientWidth;
			//console.log(self.clientHeight);
			window.onresize = function temp() {
				this.clientHeight = `${document.documentElement.clientHeight}`;
			};
		},
		watch: {
			// 如果 `clientHeight` 发生改变，这个函数就会运行
			clientHeight: function() {
				this.changeFixed(this.clientHeight)
			},
			create_range(newVal) {
				//console.log(newVal);
				if (newVal == null) {
					this.form_search.start_appointment_date = '';
					this.form_search.end_appointment_date = '';
				} else {
					this.form_search.start_appointment_date = newVal[0];
					this.form_search.end_appointment_date = newVal[1];
				}
			}
		}
	}
</script>
<style>

</style>
<style scoped>
	.status-2 {
		color: #9a9a9a;
	}

	.status-1 {
		color: #F31A5C;
	}

	.status-0 {
		color: #F27918;
	}

	.status-3 {
		color: #0C67F0;
	}

	.status-9 {
		color: #04B365;
	}

	.status-10 {
		color: #666;
	}
	.option-btn {
		margin: 5px;
	}
</style>
